import '@akpl/ui-mobile/styles.css';
import './index.css';

import { reloadOnStaleChunk } from '@akpl/shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { installPwa } from './pwa';

// UX-406: register the service worker and keep Chrome's install prompt for Profile to offer.
installPwa();
// A page left open across a deploy asks for files that no longer exist: reload instead of dying.
reloadOnStaleChunk();

const root = createRoot(document.getElementById('root')!);

/**
 * UX-437: takes the inline boot shell down once React owns the screen.
 *
 * It is also the signal `index.html` reads to decide whether an `online` event should reload a
 * page that never booted (UX-441), so it must come down exactly when the app is on screen — not
 * before, or the guest is back to looking at a black rectangle.
 */
export function dismissBootShell(): void {
  document.getElementById('akpl-boot-shell')?.remove();
}

/**
 * WP1.2's dev-only `/dev/approve?code=` page still stands in for flows the phone does not own
 * yet (it approves a pairing code with a pasted ID token). `/tv` is now the real route
 * (WP2.1/2.2), so only `/dev/approve` reaches it.
 *
 * The `import.meta.env.DEV` guard is statically false in a production build, so Rollup drops
 * the branch and the dynamic chunk with it.
 */
if (import.meta.env.DEV && window.location.pathname === '/dev/approve') {
  void import('./dev/ApproveCode').then(({ ApproveCode }) => {
    root.render(
      <StrictMode>
        <ApproveCode />
      </StrictMode>,
    );
    dismissBootShell();
  });
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  dismissBootShell();
}
